import React, {} from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Example } from 'components';
import i18n from 'i18next';

const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 20px;
`;

const ExmapleBlockUsers = () => {
	const { t } = useTranslation();

	return (
		<>

			<Container>

				<Example url={'https://images.acase.ru/sjas/xmlgw/xsd/UsersRequest.xsd'} title={t('Схема запроса')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/xsd/UsersResponse.xsd'} title={t('Схема ответа')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/UsersCreateRequest.xml'} title={t('Пример запроса') + ' ' + t('Создать')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/UsersCreateResponse.xml'} title={t('Пример успешного') + ' ' + t('Создать')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/UsersUpdateRequest.xml'} title={t('Пример запроса') + ' ' + t('Обновить')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/UsersUpdateResponse.xml'} title={t('Пример успешного') + ' ' + t('Обновить')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/UsersDeleteRequest.xml'} title={t('Пример запроса') + ' ' + t('Удалить')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/UsersDeleteResponse.xml'} title={t('Пример успешного') + ' ' + t('Удалить')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/UsersRequest.xml'} title={t('Пример запроса') + ' ' + t('Список')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/UsersResponse.xml'} title={t('Пример успешного') + ' ' + t('Список')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/UsersInfoRequest.xml'} title={t('Пример запроса') + ' ' + t('Получить')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/UsersInfoResponse.xml'} title={t('Пример успешного') + ' ' + t('Получить')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/UsersResponseError.xml'} title={t('Пример ответа с ошибкой')}/>

			</Container>
		</>
	);
};

export default ExmapleBlockUsers;